import { Activity, CheckCircle2, Database, Play, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { api, type DevSeedResponse } from "../api/client";

function isLocalHost(): boolean {
  return ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);
}

export function SettingsPage() {
  const [seedResult, setSeedResult] = useState<DevSeedResponse | null>(null);
  const [seedError, setSeedError] = useState("");
  const [seedLoading, setSeedLoading] = useState(false);
  const showLocalTools = isLocalHost();

  async function handleSeed() {
    setSeedLoading(true);
    setSeedError("");
    try {
      setSeedResult(await api.seedLocalDevData());
    } catch (error) {
      setSeedError(error instanceof Error ? error.message : String(error));
    } finally {
      setSeedLoading(false);
    }
  }

  return (
    <div className="page-stack">
      <div className="toolbar-row">
        <h2>系統狀態</h2>
      </div>
      <section className="status-grid">
        <article className="status-card">
          <Database size={18} aria-hidden="true" />
          <div>
            <strong>D1</strong>
            <span>Raw events 90 天；彙總資料至少 24 個月</span>
          </div>
        </article>
        <article className="status-card">
          <Activity size={18} aria-hidden="true" />
          <div>
            <strong>Queue + Rollup</strong>
            <span>Queue batch 後重建近 48 小時彙總並清理過期 raw events</span>
          </div>
        </article>
        <article className="status-card">
          <ShieldCheck size={18} aria-hidden="true" />
          <div>
            <strong>Google 帳號登入</strong>
            <span>新帳號需由管理員啟用，啟用前不能存取分析資料</span>
          </div>
        </article>
      </section>
      {showLocalTools ? (
        <section className="panel local-tools-panel">
          <div className="panel-heading">
            <div>
              <h3>本地測試資料</h3>
              <span>localhost only</span>
            </div>
          </div>
          <div className="local-tools-body">
            <button className="primary-action" type="button" onClick={handleSeed} disabled={seedLoading}>
              <Play size={16} aria-hidden="true" />
              <span>{seedLoading ? "建立中" : "建立測試資料"}</span>
            </button>
            {seedResult ? (
              <div className="inline-success">
                <CheckCircle2 size={16} aria-hidden="true" />
                <span>
                  已新增 {seedResult.events} / {seedResult.attemptedEvents} 筆觀看資料，{seedResult.articles} 篇文章，
                  {seedResult.from} 至 {seedResult.to}
                </span>
              </div>
            ) : null}
            {seedError ? <div className="inline-warning">{seedError}</div> : null}
          </div>
        </section>
      ) : null}
    </div>
  );
}
